// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___xBx4D","open":"open___SJfFy"};